import { Component, OnInit } from "@angular/core";

import { UserService } from "src/app/shared/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormControl, Validators, FormGroupDirective, NgForm } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { ErrorStateMatcher } from "@angular/material/core";

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  matcher = new MyErrorStateMatcher();
  isLoading: boolean = false;
  hidePassword: boolean = true;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private toast: ToastrService,
    private router: Router
  ) {
    const isAuthenticated = localStorage.getItem('currentUser');
    if (isAuthenticated)
      this.router.navigateByUrl('');

    this.loginForm = new FormGroup({
      emailAddress: new FormControl("", [Validators.required, Validators.email]),
      password: new FormControl("", [Validators.required]),
    });
  }

  ngOnInit() { }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }

  async login() {
    if (this.loginForm.valid) {
      this.isLoading = true
      try {
        await this.userService.signInWithUsernamePassword(
          this.loginForm.value
          
        );
       
        this.toast.success('Login successful, Redirecting!', '');
        this.isLoading = false;
        this.router.navigateByUrl('');
      } catch (error) {
        this.isLoading = false;
        console.log(error);
        this.toast.warning(error.error.message, '');
      }
    }
  }

  loginwithMs() {
    this.isLoading = true;
    this.userService.initiateSSOLogin();
  }
}
